import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// 휴대폰 인증번호 검증 이후 사용자 세션 정보가 내려옴.
import { selectAth0302 as athUserInfo } from 'app/core/services/com/ath.service'
// 페이지 검증 API호출 시 사용자 세션 정보가 내려옴.
import { selectCom0204, selectCom0207 } from 'app/core/services/com/com.service'
import { RootState } from 'app/core/store'

export type UserInfo = {
    /**
     * 실명번호(주민등록번호)
     */
    // rnn: string
    rnn1: string
    /**
     * 고객명
     */
    csm: string
    /**
     * 이동통신사코드(1:SKT, 2:KT, 3:LGU+, 4:SKT 알뜰폰, 5:KT 알뜰폰, 6:LGU+ 알뜰폰)
     */
    // tlfaCmcmDcd: string
	/**
	 * 전화번호 (01012345678)
	 */
	telNo: string
    /**
     * 전화번호1 (010)
     */
    telNo1: string
    /**
     * 전화번호2 (1234)
     */
    telNo2: string
    /**
     * 전화번호3 (5678)
     */
    telNo3: string
    /**
     * CI
     */
    // ci: string
    /**
     * 전행고객실명대체번호
     */
    wbcsRlnmAltrNo: string
    /**
     * 거래년월일
     */
    trnYmd: string
    /**
     * 거래내역일련번호
     */
    trhsSrn: number
    /**
     * 이용자번호
     */
    usrIdntNo?: string
    /**
     * 생년월일(yyyymmdd)
     */
    birthYmd: string
    /**
     * 전산고객번호
     */
    edpsCsn: number

    /**
     * 인증상태
     */
    authStep: string
    /**
     * 성별(1:남자, 2:여자)
     */
    // gender: string
    /** 고객CI
     * @type {string}
     */
    userCi: string
}

export type CusInfo = {
    /** 전행고객실명대체번호 */
    wbcsRlnmAltrNo: string
    /** 거래년월일 */
    trnYmd: string
    /** 거래내역일련번호 */
    trhsSrn: string

    //이어가기에서조건으로 사용할 정보
    /** 거래내역일련번호 */
    birtYmd: string
    /** 비대면실명확인진행상태코드 */
    nofcRlncPgrsScd: string

    //신분증진위확인시 생성되는정보
    /** 고객명 */
    csm: string
    /** 실명번호1 */
    rnn1: string
    /** 실명번호2 (암호화) */
    rnn2: string
    /** 휴대폰지역번호 */
    clphLln: string
    /** 휴대폰국번호 */
    clphTon: string
    /** 휴대폰개별번호 */
    clphIncsNo: string
    /** 제공동의여부 */
    ofrCosnYn: string
    /** 제공식별동의여부 */
    ofrIdntCosnYn: string

    //고객정보입력시 생성되는 정보
    /** 영문고객명 */
    ensnCsm: string
    /** 자택도로명주소구분코드 */
    oohRdndDcd: string
    /** 자택우편번호 */
    oohZpcd: string
    /** 자택우편일련번호 */
    oohPssrSrn: string
    /** 자택기본주소 */
    oohBscAdr: string
    /** 자택상세주소 */
    oohDtlAdr: string
    /** 자택건물관리번호 */
    oohBldnMngmNo: string
    /** 이메일주소 */
    ead: string
    /** 이메일ID */
    emlId: string
    /** 이메일서버코드 */
    emlSrvrCd: string
    /** 상품서비스안내동의여부 2018.10.25 상품서비스안내동의여부는 디폴트가 선택안함으로 되어야함 금소부에서 요청함(휙계좌개설은 18.09.13 적용) */
    pdfSrgnCosnYn: string
    /** SMS마케팅동의여부 */
    smsMrknCosnYn: string
    /** 이메일마케팅동의여부 */
    emlMrknCosnYn: string
    /** 휴대폰마케팅동의여부 */
    clphMrknCosnYn: string
    /** 전화마케팅동의여부 */
    telMrknCosnYn: string
    /** 우편물마케팅동의여부 */
    psmlMrknCosnYn: string
    /** 팩스마케팅동의여부 */
    faxMrknCosnYn: string
    /** 해외납세자여부 신규추가 */
    ovrsPytxObltYn: string
    /** 실명확인증표코드 */
    rlnmCnfaCrtiCd: string
    /** 발행년월일 */
    issYmd: string
    /** 거래목적코드 */
    trnObjtCd: string
    /** 자금원천구분코드 */
    fndsOrgnDcd: string
    /** 실소유자여부 */
    rlOnrYn: string
    /** 고객직업구분코드 */
    cusOcpaDcd: string
    /** 직장명 */
    wrplNm: string
    /** 직장도로명주소구분코드 */
    wrplRdndDcd: string
    /** 직장우편번호 */
    wrplZpcd: string
    /** 직장우편일련번호 */
    wrplPssrSrn: string
    /** 직장기본주소 */
    wrplBscAdr: string
    /** 직장상세주소 */
    wrplDtlAdr: string
    /** 직장건물관리번호 */
    wrplBldnMngmNo: string

    /**
     * 제휴처구분코드
     */
    alplDcd: string
    /**
     * 비대면인증채널구분코드
     */
    nofcCrtcChnlDcd: string
    /**
     * 마케팅생성부점코드
     */
    mrknCretBrcd: string
    /**
     * 마케팅생성직원번호
     */
    mrknCretEmn: string
    /**
     * 비대면콤보유형코드
     */
    nofcCmbTcd: string

    /** 삼성페이계약번호 */
    sspayContractNo: string

    ////////////////////////////////////////////////bridge에서 들어오는 정보////////////////////////////////////////////////////

    /** 권유직원명
     *  mrknCretEmn
     *
     */
    emplNm: string

    /** 영업점명 */
    bankBrncNm: string

    /**
     * 조회목적코드
     */
    cbinqObjtCd: string
    /**
     * 부점코드
     */
    brcd: string
    /**
     * 직원번호
     */
    emn: string
    /**
     * 전행고객번호
     */
    csn: string
    /**
     * 상품구분코드
     */
    gubun: string
    /**
     * 제휴처코드
     */
    acd: string
    /**
     * 그룹코드
     */
    grpcd: string
    /**
     * 상품코드
     */
    apcd: string
    /**
     * 개인입출금통장 특정 상품일 경우 파라미터 추가
     */
    nstSubparam: string
    ////////////////////////////////////////////////bridge에서 들어오는 정보////////////////////////////////////////////////////
    isGwEnter: boolean
    /** 사업자등록번호 */
    bzn: string
    /** 이벤트ID */
    evntId: string
    nfCheck: boolean
    nfSegKey: string
    idCardAuthGubun: string
    /** 펀드 고령투자자 지정인 cusInfo 파라미터 추가 */
    acn: string
    fundDgprSttsDcd: string
    invsNm: string
    fundNm: string
    newYmd: string
    sttgYmd: string
    fnshYmd: string
    fnptDcdNm: string
    rskGrd: string
    fundCd: string
    pdlnCd: string
    pdgrCd: string
    pdtmCd: string
    pdcd: string
    allPdcd: string
	pdfAddList: []
}

export type User = {
    info: UserInfo
    cusInfo: CusInfo
}

export const initialState: User = {
    info: {
        // rnn: '',
        rnn1: '',
        csm: '',
		telNo: '',
        telNo1: '',
        telNo2: '',
        telNo3: '',
        wbcsRlnmAltrNo: '',
        trnYmd: '',
        trhsSrn: 0,
        usrIdntNo: '',
        birthYmd: '',
        edpsCsn: 0,
        authStep: '',
        userCi: '',
    },
    cusInfo: {
        alplDcd: '03',
        nofcCrtcChnlDcd: '',
        mrknCretBrcd: '', // 관리부점
        mrknCretEmn: '', // 권유직원
        nofcCmbTcd: '',
        cbinqObjtCd: '',
        brcd: '',
        emn: '',
        emplNm: '',
        bankBrncNm: '',
        csn: '',
        gubun: '',
        acd: '',
        grpcd: '',
        apcd: '',
        nstSubparam: '',
        wbcsRlnmAltrNo: '',
        trnYmd: '',
        trhsSrn: '',
        birtYmd: '',
        nofcRlncPgrsScd: '',
        csm: '',
        rnn1: '',
        rnn2: '',
        clphLln: '',
        clphTon: '',
        clphIncsNo: '',
        ofrCosnYn: '',
        ofrIdntCosnYn: '',
        ensnCsm: '',
        oohRdndDcd: '',
        oohZpcd: '',
        oohPssrSrn: '',
        oohBscAdr: '',
        oohDtlAdr: '',
        oohBldnMngmNo: '',
        ead: '',
        emlId: '',
        emlSrvrCd: '',
        pdfSrgnCosnYn: '',
        smsMrknCosnYn: '',
        emlMrknCosnYn: '',
        clphMrknCosnYn: '',
        telMrknCosnYn: '',
        psmlMrknCosnYn: '',
        faxMrknCosnYn: '',
        ovrsPytxObltYn: '',
        rlnmCnfaCrtiCd: '',
        issYmd: '',
        trnObjtCd: '',
        fndsOrgnDcd: '',
        rlOnrYn: '',
        cusOcpaDcd: '',
        wrplNm: '',
        wrplRdndDcd: '',
        wrplZpcd: '',
        wrplPssrSrn: '',
        wrplBscAdr: '',
        wrplDtlAdr: '',
        wrplBldnMngmNo: '',
        sspayContractNo: '',
        isGwEnter: false,
        bzn: '',
        evntId: '',
        nfCheck: false,
        nfSegKey: '',
        idCardAuthGubun: 'idCard',
        /** 펀드 고령투자자 지정인 cusInfo 파라미터 추가 */
        acn: '',
        fundDgprSttsDcd: '',
        invsNm: '',
        fundNm: '',
        newYmd: '',
        sttgYmd: '',
        fnshYmd: '',
        fnptDcdNm: '',
        rskGrd: '',
        fundCd: '',
        pdlnCd: '',
        pdgrCd: '',
        pdtmCd: '',
        pdcd: '',
        allPdcd: '',
		pdfAddList: [],
    },
}
export const initialStateRe: User = {
    info: {
        // rnn: '',
        rnn1: '',
        csm: '',
		telNo: '',
        telNo1: '',
        telNo2: '',
        telNo3: '',
        wbcsRlnmAltrNo: '',
        trnYmd: '',
        trhsSrn: 0,
        usrIdntNo: '',
        birthYmd: '',
        edpsCsn: 0,
        authStep: '',
        userCi: '',
    },
    cusInfo: {
        alplDcd: '03',
        nofcCrtcChnlDcd: '',
        mrknCretBrcd: '', // 관리부점 설정
        mrknCretEmn: '', // 권유직원 설정
        nofcCmbTcd: '',
        cbinqObjtCd: '',
        brcd: '',
        emn: '',
        emplNm: '',
        bankBrncNm: '',
        csn: '',
        gubun: '',
        acd: '',
        grpcd: '',
        apcd: '',
        nstSubparam: '',
        wbcsRlnmAltrNo: '',
        trnYmd: '',
        trhsSrn: '',
        birtYmd: '',
        nofcRlncPgrsScd: '',
        csm: '',
        rnn1: '',
        rnn2: '',
        clphLln: '',
        clphTon: '',
        clphIncsNo: '',
        ofrCosnYn: '',
        ofrIdntCosnYn: '',
        ensnCsm: '',
        oohRdndDcd: '',
        oohZpcd: '',
        oohPssrSrn: '',
        oohBscAdr: '',
        oohDtlAdr: '',
        oohBldnMngmNo: '',
        ead: '',
        emlId: '',
        emlSrvrCd: '',
        pdfSrgnCosnYn: '',
        smsMrknCosnYn: '',
        emlMrknCosnYn: '',
        clphMrknCosnYn: '',
        telMrknCosnYn: '',
        psmlMrknCosnYn: '',
        faxMrknCosnYn: '',
        ovrsPytxObltYn: '',
        rlnmCnfaCrtiCd: '',
        issYmd: '',
        trnObjtCd: '',
        fndsOrgnDcd: '',
        rlOnrYn: '',
        cusOcpaDcd: '',
        wrplNm: '',
        wrplRdndDcd: '',
        wrplZpcd: '',
        wrplPssrSrn: '',
        wrplBscAdr: '',
        wrplDtlAdr: '',
        wrplBldnMngmNo: '',
        sspayContractNo: '',
        isGwEnter: false,
        bzn: '',
        evntId: '',
        nfCheck: false,
        nfSegKey: '',
        idCardAuthGubun: 'idCard',
        /** 펀드 고령투자자 지정인 cusInfo 파라미터 추가 */
        acn: '',
        fundDgprSttsDcd: '',
        invsNm: '',
        fundNm: '',
        newYmd: '',
        sttgYmd: '',
        fnshYmd: '',
        fnptDcdNm: '',
        rskGrd: '',
        fundCd: '',
        pdlnCd: '',
        pdgrCd: '',
        pdtmCd: '',
        pdcd: '',
        allPdcd: '',
		pdfAddList: [],
    },
}

const slice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        clear: (state) => {
            return initialState
        },
        setUserInfo: (state, action: PayloadAction<UserInfo>) => {
            state.info = action.payload
        },
        setUserInfoRnn1: (state, action: PayloadAction<string>) => {
            state.info.rnn1 = action.payload
        },
        setUserInfoObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState.info).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state.info[key] = action.payload[key]
                    }
                })
            })
        },
        setUserInfoArr: (state, action: PayloadAction<any>) => {
            action.payload.map((joinArr) => {
                state.info[joinArr.key] = joinArr.value
            })
        },
        setCusInfo: (state, action: PayloadAction<CusInfo>) => {
            state.cusInfo.alplDcd = action.payload.alplDcd
        },
        setCusInfoObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState.cusInfo).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state.cusInfo[key] = action.payload[key]
                    }
                })
            })
        },
        setCusInfoArr: (state, action: PayloadAction<any>) => {
            action.payload.map((joinArr) => {
                state.cusInfo[joinArr.key] = joinArr.value
            })
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(selectCom0207.matchFulfilled, (state, action) => {
            //제휴처 코드 검증 결과를 업데이트 한다.
            const alplDcd = action.payload?.alplDcd
            state.cusInfo.alplDcd = alplDcd
        })
        builder.addMatcher(athUserInfo.matchFulfilled, (state, action) => {
            //싹 날리고 덮어써야하나?
            const newInfo = action.payload
            for (let name in newInfo) {
                state.info[name] = newInfo[name]
            }
        })
        builder.addMatcher(selectCom0204.matchFulfilled, (state, action) => {
            //페이지 정보 검증 - 사용자 세션 정보가 내려옴.
            const newInfo = action.payload
            const oldInfo = state.info
            if (oldInfo?.edpsCsn > 0 && newInfo?.edpsCsn < 1) {
                //세션 정보가 있다가 날아간 경우다.
                //
            }
            const keys = Object.keys(initialState.info)
            if (
                newInfo?.edpsCsn === oldInfo?.edpsCsn &&
                newInfo.authStep == oldInfo.authStep
            ) {
                //데이터가 동일한 경우다. 불필요한 렌더링 막기
                return
            }
            for (let name of keys) {
                if (name in newInfo) {
                    state.info[name] = newInfo[name]

                    if (name === 'rnn1') {
                        state.cusInfo['rnn1'] = newInfo[name]
                    }
                    if (name === 'birthYmd') {
                        state.cusInfo['birthYmd'] = newInfo[name]
                    }
                    if (name === 'telNo1') {
                        state.cusInfo['clphLln'] = newInfo[name]
                    }

                    if (name === 'telNo2') {
                        state.cusInfo['clphTon'] = newInfo[name]
                    }

                    if (name === 'telNo3') {
                        state.cusInfo['clphIncsNo'] = newInfo[name]
                    }
                }
            }
        })
    },
})

export const {
    clear,
    setUserInfo,
    setUserInfoRnn1,
    setUserInfoObArr,
    setCusInfo,
    setCusInfoObArr,
    setUserInfoArr,
    setCusInfoArr,
} = slice.actions
export const selectorUserInfo = (state: RootState) => {
    return state.user.info
}
export const selectorUserInfo4Exchange = (state: RootState) => {
    const info = state.user.info
    const csm = info.csm
    const telNo = `${info.telNo1}-${info.telNo2}-${info.telNo3}`
    const birthYmd = info.birthYmd
    return { csm, telNo, birthYmd }
}
export const selectorAlplDcd = (state: RootState) => {
    const alplDcd = state.user.cusInfo.alplDcd
    return alplDcd.length > 0 ? alplDcd : '03'
}

export const selectorEvntId = (state: RootState) => {
    return state.user.cusInfo.evntId
}

export default slice.reducer
